import styles from './Metric.module.css';
import { Card } from './Card.jsx';
import { LiveBadge } from './Badge.jsx';
import { Sparkline } from './Sparkline.jsx';

/**
 * The accuracy widget: a label, one big gradient number, a trend line of copy,
 * and an optional sparkline.
 *
 * size: 'md' (design-system card) | 'lg' (dashboard hero)
 * live: show the pulsing LIVE pill in the corner
 */
export function Metric({
  label,
  value,
  trend,
  trendTone = 'win',
  sparkline,
  live = false,
  size = 'lg',
  className = '',
}) {
  return (
    <Card
      gradient={size === 'lg'}
      radius={size === 'lg' ? 'xl' : 'lg'}
      padding="lg"
      className={`${styles.metric} ${styles[size]} ${className}`}
    >
      {live && <LiveBadge className={styles.live} />}
      <div className={styles.label}>{label}</div>
      <div className={`${styles.value} mono-num`}>{value}</div>
      {trend && <div className={`${styles.trend} ${styles[trendTone]}`}>{trend}</div>}
      {sparkline?.length > 1 && (
        <div className={styles.spark}>
          <Sparkline points={sparkline} height={size === 'lg' ? 90 : 80} />
        </div>
      )}
    </Card>
  );
}

/** Compact stat tile — used in rows of three on Track Record and History. */
export function StatTile({ value, label, gradient = false, className = '' }) {
  return (
    <Card padding="md" className={`${styles.tile} ${className}`}>
      <div className={`${styles.tileValue} mono-num ${gradient ? 'grad-text' : ''}`}>{value}</div>
      <div className={styles.tileLabel}>{label}</div>
    </Card>
  );
}
